export const findFirstNonEmptyV3Slot = locationSlots => {
  for (const date in locationSlots) {
    const timeSlots = locationSlots[date];

    if (Array.isArray(timeSlots) && timeSlots.length > 0)
      // found the first non-empty array, now return the first available slot
      return {
        date,
        time: timeSlots,
      };
  }
  return null;
};
